import Vue, { DirectiveOptions, DirectiveFunction } from 'vue';

function directive(name: string) {
	const fn: DirectiveFunction = (el, binding) => {
		el.style[name] = binding.value;
	}

	Vue.directive(name, {
		bind: fn,
		update: fn
	});
}

const styles = [
	"gridGap",
	"gridColumn",
	"gridColumnStart",
	"gridColumnEnd",
	"gridRow",
	"gridRowStart",
	"gridRowEnd",
	"gridTemplateColumns",
	"gridTemplateRows"
];

styles.forEach(directive);